import { Layout } from "@/components/Layout";
import { Seo } from "@/components/Seo";

const CLAUSES = [
  {
    h: "1. Acceptance of Terms",
    p: "By accessing or using SCMBrain.com, the Intelligent SCM Scan, or any related content, tools, reports, or services (collectively, the \"Services\"), you agree to be bound by these Terms of Use. If you do not agree, you must not use the Services.",
  },
  {
    h: "2. No Professional Advice",
    p: "The Intelligent SCM Scan and all content published on SCMBrain.com are provided for informational and educational purposes only. Nothing on this platform constitutes professional, consulting, legal, financial, or investment advice, and no consultant-client relationship is formed by use of the Services. Results are based entirely on self-reported user inputs and general industry frameworks.",
  },
  {
    h: "3. Warranty Disclaimer (\"As Is\" / \"As Available\")",
    p: "All Services, reports, assessments, scores, content, and outputs are provided strictly on an \"as is\" and \"as available\" basis, without warranties of any kind, whether express, implied, or statutory. SCMBrain expressly disclaims all warranties including, without limitation, implied warranties of merchantability, fitness for a particular purpose, accuracy, reliability, non-infringement, and uninterrupted or error-free operation. You assume all risk arising from your use of the Services.",
  },
  {
    h: "4. Limitation of Liability",
    p: "To the maximum extent permitted by applicable law, SCMBrain and its owners, contributors, and affiliates shall not be liable for any direct, indirect, incidental, consequential, special, exemplary, or punitive damages arising from your use of the Services, reliance on assessment results or AI-generated outputs, or implementation of any recommendation. Your use of SCMBrain is entirely at your own risk.",
  },
  {
    h: "5. No Guarantee of Results",
    p: "SCMBrain does not guarantee any specific business outcome, performance improvement, certification, or competitive advantage resulting from use of the Intelligent SCM Scan or any other tool or content. Individual results will vary based on organizational context, implementation quality, and factors outside SCMBrain's knowledge or control.",
  },
  {
    h: "6. Acceptable Use Restrictions",
    p: "You agree not to, and not to permit any third party to: (a) scrape, crawl, harvest, or use automated means to extract data or content from the Services; (b) reverse engineer, decompile, or attempt to derive the assessment scoring methodology, question bank, or underlying logic; (c) copy, reproduce, republish, or create derivative works of the assessment framework or methodology; (d) resell, sublicense, or make any unauthorized commercial use of the Services; or (e) interfere with or disrupt the integrity or performance of the platform. Any such activity is a material breach of these Terms.",
  },
  {
    h: "7. Trademark & Brand Protection",
    p: "\"SCMBrain\", the SCMBrain name and branding, the SCMBrain logo, \"Intelligent SCM Scan\", the assessment questions, scoring methodology, maturity level definitions, and all related visual and written assets are the proprietary intellectual property of SCMBrain, protected under applicable trademark and copyright law. These marks and materials may not be used, reproduced, or referenced commercially without SCMBrain's prior written permission.",
  },
  {
    h: "8. Self-Reported Data",
    p: "Assessment results are generated based entirely on information provided by the user. SCMBrain does not independently verify any user-submitted data. The accuracy and usefulness of results are directly dependent on the honesty and accuracy of user responses. SCMBrain accepts no responsibility for results generated from inaccurate or misleading inputs.",
  },
  {
    h: "9. Data Privacy",
    p: "Your use of the Services is also governed by our Privacy Policy, which explains how we collect, use, and protect your data. By using the Services, you consent to the practices described in the Privacy Policy.",
  },
  {
    h: "10. Governing Law & Jurisdiction",
    p: "These Terms shall be governed by and construed in accordance with the laws of India, without regard to its conflict-of-law principles. You irrevocably agree that the courts located in India shall have exclusive jurisdiction to resolve any dispute arising out of or in connection with these Terms or your use of the Services.",
  },
  {
    h: "11. Changes to These Terms",
    p: "SCMBrain may revise these Terms at any time. Continued use of the Services after changes are posted constitutes acceptance of the revised Terms.",
  },
];

export default function Terms() {
  return (
    <Layout>
      <Seo
        title="Terms of Use | SCMBrain"
        description="The Terms of Use governing access to SCMBrain, the Intelligent SCM Scan, and all related content, tools, and AI-generated reports."
        path="/terms"
      />
      <section className="max-w-3xl mx-auto px-6 md:px-12 py-20">
        <p className="text-sm uppercase tracking-[0.2em] text-[#1A6B5A] font-semibold mb-4">Legal</p>
        <h1 className="font-heading text-4xl sm:text-5xl font-extrabold text-[#1B3A6B]">Terms of Use</h1>
        <p className="mt-4 text-[#94A3B8] text-sm">Last updated: February 2026</p>

        <div className="mt-10 space-y-9">
          {CLAUSES.map((c) => (
            <div key={c.h}>
              <h2 className="font-heading text-lg font-bold text-[#1B3A6B] mb-2">{c.h}</h2>
              <p className="text-[#3E577A] leading-relaxed text-[15px]">{c.p}</p>
            </div>
          ))}
        </div>
      </section>
    </Layout>
  );
}
